import { render, staticRenderFns } from "./table-filter-pill-panel.vue?vue&type=template&id=2af1f804&scoped=true&"
import script from "./table-filter-pill-panel.vue?vue&type=script&lang=js&"
export * from "./table-filter-pill-panel.vue?vue&type=script&lang=js&"
import style0 from "./table-filter-pill-panel.vue?vue&type=style&index=0&id=2af1f804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af1f804",
  null
  
)

export default component.exports